import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import React from 'react'
import './share.css'
import Header from '../Aside/Header'
import { ToolbarContainer } from '../../Toolbar/Toolbar'

export class Share extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        close: PropTypes.func.isRequired,
        getShareActions: PropTypes.func.isRequired,
    }

    render() {
        const { t, close, getShareActions } = this.props

        return (
            <React.Fragment>
                <Header
                    className='collaborative-indexations-header'
                    close={close}
                    title={t('visualizer:toolbar.left.share.title')}
                />
                <ToolbarContainer type='horizontal' name='share' itemsSupplier={getShareActions} />
            </React.Fragment>
        )
    }
}

export default withTranslation()(Share)
